<div class="modal-header"><h2 class="modal-title">Payment Details</h2></div>
<div class="modal-body skinny">
    <dx-form *ngIf="payment" [formData]="payment" validationGroup="paymentValidationGroup">
        <dxi-item itemType="group" [colCount]="3">
            <dxi-item itemType="group" caption="Payment Info" [colSpan]="2" [colCount]="2">
                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item [label]="{ text: 'Dealer' }" [colSpan]="2">
                        <div *dxTemplate>
                            <dx-text-box [value]="dealer.companyName" [disabled]="true"> </dx-text-box>
                        </div>
                    </dxi-item>

                    <dxi-item
                        dataField="paymentDate"
                        editorType="dxDateBox"
                        [label]="{ text: 'Payment Date' }"
                        [editorOptions]="{ disabled: payment.quickBooksId || payment.quickBooksLastExport }"
                    >
                        <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>

                    <dxi-item [label]="{ text: 'Method' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="payment.paymentMethodId"
                                [items]="paymentMethods"
                                [valueExpr]="'id'"
                                [displayExpr]="'name'"
                                searchEnabled="true"
                                searchMode="startswith"
                                [disabled]="payment.quickBooksId || payment.quickBooksLastExport"
                                (onValueChanged)="onMethodUpdate($event)"
                            >
                            </dx-select-box>
                        </div>
                        <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                        <dxi-validation-rule type="range" [min]="1" [message]="'Required'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item dataField="referenceNumber" [label]="{ text: 'Reference #' }" [editorOptions]="{ disabled: payment.quickBooksId || payment.quickBooksLastExport }">
                        <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                    </dxi-item>

                    <dxi-item *ngIf="payment.paymentMethodId === 3" [label]="{ text: 'Credit Card' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="payment.creditCardId"
                                [items]="creditCards"
                                [valueExpr]="'id'"
                                [displayExpr]="'name'"
                                searchEnabled="true"
                                searchMode="startswith"
                            >
                            </dx-select-box>
                        </div>
                    </dxi-item>

                    <dxi-item *ngIf="payment.paymentMethodId === 3" [label]="{ text: 'Last Four Digits' }">
                        <dx-number-box [(value)]="payment.creditCardLastDigits" [step]="0"> </dx-number-box>
                        <dxi-validation-rule type="range" [min]="1000" [max]="9999" [message]="'Must be between 1000 and 9999'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item *ngIf="canAddNorthPointFee" [label]="{ text: 'NorthPoint Fee' }">
                        <!-- <div *dxTemplate class="d-flex"> -->
                        <dx-number-box [(value)]="payment.northPointFee" [format]="{ type: 'currency', precision: 2 }" [step]="0" [disabled]="!isNewPayment"> </dx-number-box>
                        <!-- </div> -->
                        <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                        <dxi-validation-rule type="range" [min]="0.01" [message]="'Must be more than $0.01'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item *ngIf="canAddNorthPointFee">
                        <div *dxTemplate>
                            <button *ngIf="canAddNorthPointFee && payment.northPointFee > 0" class="btn btn-sm btn-success mt-1 ml-2" (click)="addNorthPointLines()">
                                Add Fee
                            </button>
                        </div>
                    </dxi-item>

                    <!-- <dxi-item *ngIf="canAddNorthPointFee" itemType="empty"></dxi-item> -->

                    <dxi-item [label]="{ text: 'Lines Total' }">
                        <div *dxTemplate>
                            <dx-number-box [value]="totalBalance" [disabled]="true" [format]="{ type: 'currency', precision: 2 }"> </dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item *ngIf="mode !== 'invoices'" itemType="empty"></dxi-item>
                    <dxi-item *ngIf="mode === 'invoices'" [label]="{ text: 'Freight' }">
                        <div *dxTemplate>
                            <dx-number-box [value]="totalFreight" [disabled]="true" [format]="{ type: 'currency', precision: 2 }"> </dx-number-box>
                        </div>
                    </dxi-item>

                    <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
                        <dxi-item [label]="{ text: 'Total' }">
                            <div *dxTemplate class="d-flex">
                                <dx-number-box
                                    [(value)]="payment.total"
                                    [format]="{ type: 'currency', precision: 2 }"
                                    [step]="0"
                                    [readOnly]="selectedMode === 'Pay Full Amount'"
                                    [disabled]="!isNewPayment"
                                >
                                </dx-number-box>
                            </div>
                            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                            <dxi-validation-rule type="range" [min]="0.0" [message]="'Payment Amount must be more than $0'"></dxi-validation-rule>
                            <dxi-validation-rule
                                type="custom"
                                message="Payment Total must equal the amount applied to each line"
                                [validationCallback]="validatePaymentTotal"
                                [reevaluate]="true"
                            ></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate>
                                <button *ngIf="selectedMode === 'Pay Custom Amount'" class="btn btn-sm btn-success mt-1 ms-2" (click)="autoApplyPartialPayment()">
                                    Auto-Apply
                                </button>
                            </div>
                        </dxi-item>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" [colCount]="2">
                    <dxi-item [label]="{ text: 'Notes' }" [colSpan]="2">
                        <div *dxTemplate>
                            <dx-text-area [(value)]="payment.notes" [height]="150"> </dx-text-area>
                        </div>
                    </dxi-item>

                    <dxi-item *ngIf="isNewPayment" [label]="{ text: 'Mode' }">
                        <div *dxTemplate>
                            <dx-select-box [(value)]="selectedMode" [items]="paymentModes" (onValueChanged)="onModeUpdate($event)" [disabled]="!isNewPayment"> </dx-select-box>
                        </div>
                        <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item *ngIf="selectedMode === 'Apply Percentage'" [label]="{ text: 'Percentage' }">
                        <div *dxTemplate>
                            <dx-number-box [(value)]="percentage" (onValueChanged)="onPercentageChanged($event)"> </dx-number-box>
                        </div>
                        <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                        <dxi-validation-rule type="range" [min]="0" [message]="'Must be greater than 0'"></dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" caption="Credits" [colCount]="2">
                <dx-data-grid
                    #creditsGrid
                    keyExpr="id"
                    height="250px"
                    [dataSource]="dealerCredits"
                    [columnAutoWidth]="false"
                    (onRowDblClick)="rowDoubleClick($event)"
                    [showBorders]="true"
                >
                    <dxi-column dataField="id" width="65" [visible]="false"></dxi-column>
                    <dxi-column dataField="created" width="90"></dxi-column>
                    <dxi-column dataField="creditAmount" caption="Total" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                    <!-- <dxi-column dataField="availableAmount" caption="Available" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column> -->
                    <dxi-column dataField="paymentCreditType.name" caption="Type" width="120"></dxi-column>
                    <dxi-column dataField="applied" width="100"></dxi-column>
                    <dxi-column dataField="fromPaymentId" width="100"></dxi-column>
                    <dxi-column dataField="appliedToPaymentId" width="100"></dxi-column>
                    <dxi-column width="10"></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'"></div>
                    <div *dxTemplate="let data of 'toolbarText'"></div>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                    <dxo-filter-row [visible]="false"></dxo-filter-row>
                    <dxo-selection mode="single"></dxo-selection>
                </dx-data-grid>
            </dxi-item>
        </dxi-item>
    </dx-form>
    <div class="m-2 grid-fill">
        <dx-data-grid
            #linesGrid
            [dataSource]="invoiceLines"
            keyExpr="id"
            height="650px"
            [columnAutoWidth]="false"
            (onExporting)="onExporting($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onRowDblClick)="rowDoubleClick($event)"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChanged($event)"
            class="lines-grid"
            [sorting]="'none'"
            [showBorders]="true"
        >
            <dxi-column dataField="displayOrder" [visible]="false" width="100" [sortIndex]="0" [sortOrder]="'asc'" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="id" width="65" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="orderLine.order.invoiceNumber" caption="SalesOrder #" width="100" [sortIndex]="1" [sortOrder]="'asc'" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="packingSlip.packingSlipNumber" caption="PackSlip #" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="packingSlip.invoiceNumber" caption="Invoice #" width="100" [sortOrder]="'asc'" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="quantity" caption="Qty" width="65" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="orderLine.partNumber" caption="Part #" width="200" cellTemplate="partNumberTemplate" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="vIN" caption="VIN #" width="175" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="parentAmount" caption="Total" width="130" alignment="right" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="paymentTotal" caption="Payments" width="130" alignment="right" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
            <dxi-column
                dataField="parentBalance"
                caption="Balance"
                width="130"
                alignment="right"
                [format]="{ type: 'currency', precision: 2 }"
                [allowEditing]="false"
                [visible]="isNewPayment"
            ></dxi-column>
            <dxi-column
                dataField="amount"
                width="130"
                alignment="right"
                [allowEditing]="isNewPayment"
                [visible]="isNewPayment"
                [format]="{ type: 'currency', precision: 2 }"
            ></dxi-column>
            <dxi-column width="100"></dxi-column>

            <div *dxTemplate="let cell of 'partNumberTemplate'">
                <div class="parent-part-number" *ngIf="cell.data.orderLine.partId && !cell.data.orderLine.parentLineId && !cell.data.orderLine.isReplacement">{{ cell.text }}</div>
                <div class="replacement-part-number" *ngIf="cell.data.orderLine.isReplacement">{{ cell.text }}</div>
                <div class="misc-part-number" *ngIf="cell.data.paymentLineTypeId !== 7 && !cell.data.orderLine.partId && !cell.data.orderLine.isReplacement">{{ cell.text }}</div>
                <div class="option-part-number" *ngIf="cell.data.orderLine.parentLineId">{{ cell.text }}</div>
                <div class="fee-part-number" *ngIf="cell.data.paymentLineTypeId === 7">{{ cell.text }}</div>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-sm btn-danger ms-2" (click)="remove()" [disabled]="linesGrid.instance.getSelectedRowsData().length === 0" [hidden]="!isNewPayment">
                    Remove Line(s)
                </button>

                <button class="btn btn-sm btn-danger ms-2" (click)="addFeeLine()" [hidden]="!isNewPayment || mode !== 'invoices'">Add Fee Line</button>
                <button class="btn btn-sm btn-danger ms-2" (click)="addOverpaymentLine()" [hidden]="!isNewPayment">Add OverPayment Line</button>
            </div>
            <div *dxTemplate="let data of 'toolbarTextStart'">
                <span class="ms-1 me-2 payment-smaller-text">
                    <strong> Selected Amount: {{ selectedAmount | currency }} </strong>
                </span>
            </div>
            <div *dxTemplate="let data of 'toolbarButtonsStart'">
                <div *ngIf="!!payment && isNewPayment && overPayments?.length > 0">
                    <button class="btn btn-sm btn-primary ms-5" (click)="payWithPreviousOverPayment()" [disabled]="linesGrid.instance.getSelectedRowsData().length === 0">
                        Pay with Previous OverPayment
                    </button>
                    <span class="ms-1 me-2 payment-smaller-text">
                        <strong> Available Amount: {{ availableOverPaymentAmount | currency }} </strong>
                    </span>
                </div>
            </div>

            <div *dxTemplate="let data of 'toolbarButtonsEnd'">
                <button
                    class="btn btn-sm btn-success ms-2"
                    (click)="addCreditLine()"
                    [hidden]="!isNewPayment"
                    [disabled]="creditsGrid?.instance.getSelectedRowsData().length === 0 || creditsGrid?.instance.getSelectedRowsData()[0].appliedToPaymentId"
                >
                    Apply Selected Credit
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="selectedMode === 'Pay Custom Amount'" class="me-2"
                    ><strong
                        ><i>{{ ' Double click lines to apply payment' }}</i></strong
                    ></span
                >
            </div>

            <dxo-export [enabled]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-editing [mode]="'cell'" [allowUpdating]="true"></dxo-editing>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-summary>
                <dxi-total-item column="parentAmount" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                <dxi-total-item column="paymentTotal" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                <dxi-total-item column="parentBalance" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                <dxi-total-item column="amount" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
            </dxo-summary>
        </dx-data-grid>
    </div>
</div>

<div class="modal-footer">
    <button *ngIf="payment" class="btn btn-danger me-auto" [hidden]="!canDelete" (click)="delete()">Delete</button>
    <button class="btn btn-secondary me-4" (click)="save()" [hidden]="payment?.quickBooksId">Save without Exporting</button>
    <button class="btn btn-success" (click)="save(true)" [hidden]="payment?.quickBooksId">Save as Ready To Export</button>
    <button class="btn btn-secondary" (click)="close()">{{ payment && payment.quickBooksId ? 'Close' : 'Cancel' }}</button>
</div>
